import { LANG_CONSTANTS } from '../actionTypes'
import { IntlActions } from 'react-redux-multilingual'
import { LocalStorageService } from '../../utils'

export const languageAction = {
	openLanguagePopup,
	closeLanguagePopup,
	updateLanguage,
	updateLanguageLocale,
}
// TERMS & CONDITIONS
function openLanguagePopup() {
	return (dispatch) => {
		dispatch(open())
	}
	function open() {
		return { type: LANG_CONSTANTS.LANGUAGE_POPUP_OPEN }
	}
}

function closeLanguagePopup() {
	return (dispatch) => {
		dispatch(close())
	}

	function close() {
		return { type: LANG_CONSTANTS.LANGUAGE_POPUP_CLOSE }
	}
}

function updateLanguage() {
	return (dispatch) => {
		dispatch(set_locale())
		dispatch(locale_updated())
	}

	function set_locale() {
		return {
			type: LANG_CONSTANTS.SET_LANGUAGE_LOCALE,
		}
	}
	function locale_updated() {
		return {
			type: LANG_CONSTANTS.UPDATE_LANGUAGE_LOCALE,
		}
	}
}

function updateLanguageLocale(lang_locale) {
	return (dispatch) => {
		LocalStorageService._updateInSessionStorage('locale', lang_locale)
		dispatch(IntlActions.setLocale(lang_locale))
		dispatch(locale_updated(lang_locale))
	}

	function locale_updated(lang_locale) {
		return {
			type: LANG_CONSTANTS.CHANGE_LANGUAGE_LOCALE,
			locale: lang_locale,
		}
	}
}
